import { useEffect, useRef } from 'react';

export function InfoSlider({ children, onClose }) {
	const sliderRef = useRef(null);

	useEffect(() => {
		function close(e) {
			if (!sliderRef.current?.contains(e.target)) {
				onClose();
			}
		}

		// Delay adding the listener to skip the initial click
		const timeoutId = setTimeout(() => {
			document.addEventListener('click', close);
		}, 0);

		return () => {
			clearTimeout(timeoutId);
			document.removeEventListener('click', close);
		};
	}, [onClose]);

	return (
		<div ref={sliderRef} onClick={(e) => e.stopPropagation()}>
			{children}
		</div>
	);
}
